import type { ChatMessage } from '@cortex/web-api/clients/web/api';

const STYLE_INBOUND: React.CSSProperties = {
  alignSelf: 'flex-end',
  background: 'var(--ink)',
  color: 'var(--paper)',
  borderRadius: '18px 18px 4px 18px',
};

const STYLE_OUTBOUND: React.CSSProperties = {
  alignSelf: 'flex-start',
  background: 'var(--paper-2)',
  color: 'var(--ink)',
  borderRadius: '18px 18px 18px 4px',
  border: '1px solid var(--rule)',
};

/**
 * One message in the conversation. "Inbound" from the DB perspective means
 * "user-sent" — render those as the user's bubble (right side, ink fill).
 * "Outbound" from the DB perspective means "agent-sent" — render those as
 * the agent's bubble (left side, paper-2 fill).
 */
export function MessageBubble({ message }: { message: ChatMessage }) {
  const isUser = message.direction === 'inbound';
  return (
    <div
      style={{
        ...(isUser ? STYLE_INBOUND : STYLE_OUTBOUND),
        padding: '10px 14px',
        maxWidth: '80%',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-body)',
        lineHeight: 'var(--lh-body)',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
      }}
    >
      {message.body}
    </div>
  );
}
